import { isEmpty } from 'lodash';

const LOCAL_STORAGE_KEY = 'authorization';

const getEncryptedHeader = (usr, pwd) => {
  const credentials = btoa(`${usr}:${pwd}`);
  const basic = `Basic ${credentials}`;
  return basic;
};

export const setAuthLocalStorage = (value) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, value);
};

export const getAuthLocalStorage = () => {
  const authorization = localStorage.getItem(LOCAL_STORAGE_KEY);
  return authorization;
};

export const clearAuthLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

const getAuthHeader = (username, password) => {
  let authHeader = getAuthLocalStorage();
  if (authHeader) {
    return authHeader;
  }
  if (username && password) {
    authHeader = getEncryptedHeader(username, password);
    return authHeader;
  }
  throw new Error('missing credentials');
};

export const remove = () => {
  $('#overlay-staging-auth').off('tap', '#js-credentials-form');
  $('#overlay-staging-auth').remove();
};

export const checkIfStagingAndSdk = () => {
  const baseUrl = Pollfish.helper.getBaseRequestURL();
  const isStagingEnv = baseUrl.includes('staging');
  const isSDK = Pollfish.helper.isSDK();
  return isSDK && isStagingEnv;
};

function makeRequestToEnsureAuthNeeded({ username, password } = {}) {
  let baseUrl = Pollfish.helper.getBaseRequestURL();
  if (Pollfish.helper.isDevelopment() || Pollfish.helper.isCypressEnv()) {
    baseUrl = 'http://localhost:8082';
  }
  const authHeader = getAuthHeader(username, password);
  const isStagingAndSdk = checkIfStagingAndSdk();
  if (isStagingAndSdk) {
    $.ajax({
      cors: true,
      headers: {
        authorization: authHeader,
        'Access-Control-Allow-Origin': '*',
      },
      url: `${baseUrl}/readiness`,
      error: function Error() {
        // eslint-disable-next-line no-use-before-define
        renderStagingAuth({ error: true });
      },
      success: function onSuccess() {
        const auth = getAuthHeader(username, password);
        setAuthLocalStorage(auth);
        remove();
      },
    });
  }
}

const shouldRenderStagingAuth = () => {
  const isStagingAndSdk = checkIfStagingAndSdk();
  const authorization = getAuthLocalStorage();
  return isStagingAndSdk && !authorization;
};

export const renderStagingAuth = ({ error } = {}) => {
  const isStagingAndSdk = checkIfStagingAndSdk();
  if (!isStagingAndSdk) {
    return;
  }
  const shouldRender = shouldRenderStagingAuth();
  if (!shouldRender && !error) {
    makeRequestToEnsureAuthNeeded();
    return;
  }

  // remove previous instances of this element in case it already exists
  $('#overlay-staging-auth').remove();
  const element = `
    <div
      id="overlay-staging-auth"
      class="flex background-white flex-justify--center"
      style="position: fixed; top:0; left:0; bottom:0; right:0; z-index: 9999;"
    >
      <form id="js-credentials-form" class="flex flex-column answers-wrapper" style="margin: 5% auto;">
        <label for="js-credentials-username"><b>Username</b></label>
        <input type="text" placeholder="Enter Username" id="js-credentials-username" required></input>
        <label class="margin-sm-top" for="js-credentials-password"><b>Password</b></label>
        <input type="password" placeholder="Enter Password" id="js-credentials-password" required></input>
        <button class="margin-xl-top" type="submit">Sign In</button>
        <div style="color:#e44044; margin-top: 5px;">${
          error ? 'There was something wrong with the request' : ''
        }</div>
      </form>
    </div>
  `;

  $('body').append(element);
  $('#overlay-staging-auth').on('submit', '#js-credentials-form', (e) => {
    e.preventDefault();
    const username = $('#js-credentials-username').val();
    const password = $('#js-credentials-password').val();
    if (!isEmpty(username) && !isEmpty(password)) {
      makeRequestToEnsureAuthNeeded({ username, password });
    }
  });
};
